
<template>

  <span class="word-wrapper">
    <span v-on:click.prevent="select" class="word">{{word}}</span>
  </span>



</template>

<script>
import Vue from 'vue'

export default {
  props: ['word'],
  components: {
    // DynamicRenderer,
  },

  methods: {
    select() {
      this.$store.dispatch('studier/answerKeyword', {answer: this.word})
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="sass" scoped>

.word-wrapper {
  font-size: 15px;
  margin: 0 3px 6px 3px;
  display:inline-block;
}

.word {
  cursor: pointer;
  background: #DDDDDD;
  border-radius: 5px;
  padding:3px 6px;
}

.word:hover {
  background: #CCCCCC;
}

</style>



// WEBPACK FOOTER //
// WordbankWord.vue?6a518590